import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";

const officeData = [
  {
    region: "Australia",
    flag: "🇦🇺",
    contacts: [
      {
        name: "Rona Zou",
        role: "Chairman",
        phone: "+61 0474 320 181",
        email: "admin@dhitrading.com.au",
        address: "Unit 3, 3273 Logan Road\nUnderwood, QLD 4119",
      },
      {
        name: "Sunbi Fang",
        role: "General Manager",
        phone: "+61 0452 615 201",
        email: "sunbi@dhitrading.com.au",
        address: null,
      },
    ],
  },
  {
    region: "China",
    flag: "🇨🇳",
    contacts: [
      {
        name: "Rona Zou",
        role: "Chairman",
        phone: "+86 13636655229",
        email: "admin@dhitrading.com.au",
        address: "9F, 9#, Lane 803, Shuangcheng Road\nBaoshan District, Shanghai",
      },
    ],
  },
];

const Contact: React.FC = () => {
  return (
    <Box
      component="section"
      sx={{
        bgcolor: "#f7f9fc",
        py: { xs: 8, md: 10 },
        px: 2,
        color: "inherit",
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          align="center"
          sx={{ fontWeight: 700, mb: 1, fontFamily: "Roboto, sans-serif", color: "#1a1a2e" }}
        >
          Get In Touch
        </Typography>
        <Typography
          variant="body1"
          align="center"
          sx={{ color: "#888", mb: 6, fontFamily: "Roboto, sans-serif" }}
        >
          Our offices in Australia and China are ready to assist you.
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {officeData.map((office) => (
            <Grid item xs={12} md={5} key={office.region}>
              <Box>
                {/* Region header */}
                <Box sx={{ display: "flex", alignItems: "center", mb: 2, gap: 1 }}>
                  <Typography variant="h5" sx={{ lineHeight: 1 }}>
                    {office.flag}
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 700, fontFamily: "Roboto, sans-serif", color: "#1a1a2e" }}
                  >
                    {office.region}
                  </Typography>
                </Box>

                {/* Contacts */}
                {office.contacts.map((c, i) => (
                  <Box
                    key={c.name}
                    sx={{
                      pt: i > 0 ? 2 : 0,
                      mt: i > 0 ? 2 : 0,
                      borderTop: i > 0 ? "1px solid #e0e4ed" : "none",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 600, fontFamily: "Roboto, sans-serif", mb: 0.25, color: "#1a1a2e" }}
                    >
                      {c.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: "#888",
                        fontWeight: 500,
                        mb: 1.5,
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "0.8rem",
                      }}
                    >
                      {c.role}
                    </Typography>
                    {c.address && (
                      <Typography
                        variant="body2"
                        sx={{ color: "#666", mb: 0.75, fontFamily: "Roboto, sans-serif", whiteSpace: "pre-line" }}
                      >
                        {c.address}
                      </Typography>
                    )}
                    <Typography
                      variant="body2"
                       sx={{ color: "#666", mb: 0.5, fontFamily: "Roboto, sans-serif" }}
                    >
                      {c.phone}
                    </Typography>
                    <Typography
                      component="a"
                      href={`mailto:${c.email}`}
                      variant="body2"
                      sx={{
                        color: "#666",
                        textDecoration: "none",
                        fontFamily: "Roboto, sans-serif",
                        "&:hover": { color: "#1a1a2e", textDecoration: "underline" },
                      }}
                    >
                      {c.email}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Grid>
          ))}
        </Grid>

        <Typography
          variant="body2"
          align="center"
          sx={{ color: "#bbb", mt: 8, fontFamily: "Roboto, sans-serif" }}
        >
          © {new Date().getFullYear()} DH Technologies Pty Ltd. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Contact;
